import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../utils/Config';

function useResume(token, apiCandidateID, refetchTrigger) {
    const [resume, setResume] = useState(null);
    const baseUrl = getApiBaseUrl();
    const [isResumeLoading, setIsResumeLoading] = useState(true); // Add loading state

    useEffect(() => {
        if (token && apiCandidateID) {
            const fetchResume = async () => {
                setIsResumeLoading(true);
                try {
                    const response = await fetch(
                        `${baseUrl}/api/Attachment/GetCandidateCV?candidateId=${apiCandidateID}`,
                        {
                            mode: 'cors',
                            headers: {
                                "Authorization": `Bearer ${token}`
                            }
                        }
                    );
                    if (!response.ok) {
                        throw new Error("Failed to fetch resume");
                    }
                    const data = await response.json();
                    setResume(data.result);
                } catch (error) {
                    console.error("Failed to fetch resume URL:", error);
                } finally {
                    setIsResumeLoading(false);
                }
            };

            fetchResume();
        }
    }, [token, apiCandidateID, baseUrl, refetchTrigger]);

    return { resume, isResumeLoading }; 
}

export default useResume;
